__turbopack_context__.v({
  "clear": "Autocomplete-module__wlaoJa__clear",
  "container": "Autocomplete-module__wlaoJa__container",
  "createItem": "Autocomplete-module__wlaoJa__createItem",
  "disabled": "Autocomplete-module__wlaoJa__disabled",
  "empty": "Autocomplete-module__wlaoJa__empty",
  "error": "Autocomplete-module__wlaoJa__error",
  "errorText": "Autocomplete-module__wlaoJa__errorText",
  "helperText": "Autocomplete-module__wlaoJa__helperText",
  "input": "Autocomplete-module__wlaoJa__input",
  "inputGroup": "Autocomplete-module__wlaoJa__inputGroup",
  "item": "Autocomplete-module__wlaoJa__item",
  "label": "Autocomplete-module__wlaoJa__label",
  "popup": "Autocomplete-module__wlaoJa__popup",
  "positioner": "Autocomplete-module__wlaoJa__positioner",
  "sizeLg": "Autocomplete-module__wlaoJa__sizeLg",
  "status": "Autocomplete-module__wlaoJa__status",
  "viewport": "Autocomplete-module__wlaoJa__viewport",
});
